const constants = {
    NODE_ENV: process.env.NODE_ENV,
    MATOMO_URL: process.env.VUE_APP_MATOMO_URL,
    MATOMO_ID: process.env.VUE_APP_MATOMO_ID,
};

export default constants;
